export const getDomiciliationValues = (state = initialState) => {
  return state.domiciliationReducer;
};
